/**
 * CustomerSpeed.API
 * API that manages account-specific speed limit overrides.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * DTO for creating a new speed override.
 */
export interface CreateOverrideDto {
  /**
   * The user-defined name for this override. Example: \"US-101 Construction Zone\"
   */
  name: string | null;
  /**
   * The HERE segment references for this override. Supports multiple segments per override. Example: [\"here:cm:segment:478065967#0.588601\", \"here:cm:segment:478065968#0.123\"]
   */
  hereSegmentRefs: Array<string> | null;
  /**
   * Optional notes about this override (max 100 characters).
   */
  notes?: string | null;
  /**
   * The city name for this override\'s road segment, if available. Sourced from the Segment API\'s RoadInfoDto.City by the frontend.
   */
  cityName?: string | null;
  /**
   * The direction of travel for this override (FORWARD, BACKWARD, or BOTH).
   */
  direction: CreateOverrideDto.DirectionEnum;
  /**
   * The speed override value in km/h. Must be between 5 and 9999 inclusive.
   */
  speedOverwriteInKmh: number;
  /**
   * The start date for this override. Must not be in the past.
   */
  startDate: string;
  /**
   * The optional end date for this override. When provided, must be after StartDate.
   */
  endDate?: string | null;
}
export namespace CreateOverrideDto {
  export type DirectionEnum = 'FORWARD' | 'BACKWARD' | 'BOTH';
  export const DirectionEnum = {
    Forward: 'FORWARD' as DirectionEnum,
    Backward: 'BACKWARD' as DirectionEnum,
    Both: 'BOTH' as DirectionEnum
  };
}
